import { useAuthStore } from '@/stores/auth'
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useWebportalStore } from './../stores/webportal';
import { useMenuStore } from '@/stores/menu';
import { MenuItem } from '@/models/MenuItem';

const loginGuard = async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const authStore = useAuthStore()
  const menuStore = useMenuStore()

  if(authStore.VLtoken){    
    if(to.name == 'Login') {
      await menuStore.getMenuItems()
      await useWebportalStore().getWebPortals();  
      const home = menuStore.homePage;
      menuStore.currentItem = home as MenuItem;
      if (home?.Embed) {
        next(`/embed/${home.ID}`)
      } else if (home?.Content) {
        next(`/content/${home.ID}`)
      } else if (home?.Url) {
        next(home.Url)
      } else {
        next()
      }
    } else {      
      next();
    }
  } else {
    next();
  }
}

export default loginGuard